export function mapEventsToActivities(events = []) {
  return events.map((event) => ({
    id: event.id,
    title: event.title,
    public_id: event.event_public_id,
    link: `/events/id/${event.event_public_id}`,
    date: event.event_date,
  }));
}
